(function () {
  'use strict';

  if (window.__qaCustomBound) return;
  window.__qaCustomBound = true;

  var activeWrap = null;
  var programmaticScroll = false;

  function clearPreview(pop) {
    if (!pop) return;
    pop.classList.remove('qa-preview-active');
    var img = pop.querySelector('.qa-preview-img');
    if (img) img.removeAttribute('src');
    var priceEl = pop.querySelector('.qa-preview-price');
    if (priceEl) priceEl.textContent = '';
    var nameEl = pop.querySelector('.qa-preview-name');
    if (nameEl) { nameEl.textContent = ''; nameEl.removeAttribute('data-name-key'); }
    var badgeEl = pop.querySelector('.qa-preview-badge');
    if (badgeEl) { badgeEl.hidden = true; badgeEl.textContent = ''; }
    var variantEl = pop.querySelector('.qa-preview-variant');
    if (variantEl) variantEl.textContent = '';
    // Reset the mobile "tap once to preview, tap again to add" armed state.
    var armed = pop.querySelectorAll('.qa-pill[data-qa-armed]');
    for (var i = 0; i < armed.length; i++) armed[i].removeAttribute('data-qa-armed');
    // No variant is selected any more, so Buy Now has nothing to buy.
    syncBuyNowButton(pop, null);
  }

  // Touch / no-hover devices can't hover to see the preview, so on those we make
  // the first tap of a pill preview it and the second tap add it to cart.
  function isTouchLike() {
    return !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
  }

  // On phones the card-anchored dropdown is too narrow, so we render the popover
  // as a full-width bottom sheet with a dimmed backdrop instead.
  function isMobileViewport() {
    return window.innerWidth < 750;
  }

  function showBackdrop() {
    var bd = document.getElementById('qa-backdrop');
    if (!bd) {
      bd = document.createElement('div');
      bd.id = 'qa-backdrop';
      bd.className = 'qa-backdrop';
      bd.addEventListener('click', closeActive);
      document.body.appendChild(bd);
    }
    bd.getBoundingClientRect(); // force reflow so the fade-in transition runs
    bd.classList.add('qa-backdrop-active');
  }

  function hideBackdrop() {
    var bd = document.getElementById('qa-backdrop');
    if (bd) bd.classList.remove('qa-backdrop-active');
  }

  // Mobile sheet: show the brand + product name at the top so it's clear which
  // product was opened, even before a variant is tapped. Pulled from any pill's
  // data attributes (they all share the same product identity).
  function setSheetTitle(wrap) {
    var pop = wrap && (wrap.__qaPop || wrap.querySelector('.qa-popover'));
    if (!pop) return;
    removeSheetTitle(pop);
    var pill = pop.querySelector('.qa-pill');
    if (!pill) return;
    var brand = pill.getAttribute('data-brand') || '';
    var scent = pill.getAttribute('data-musk-name') || pill.getAttribute('data-product-title') || '';
    if (!brand && !scent) return;
    var title = document.createElement('div');
    title.className = 'qa-sheet-title';
    if (brand) {
      var b = document.createElement('span');
      b.className = 'qa-preview-brand';
      b.textContent = brand;
      title.appendChild(b);
    }
    if (scent) {
      var s = document.createElement('span');
      s.className = 'qa-preview-scent';
      s.textContent = scent;
      title.appendChild(s);
    }
    pop.insertBefore(title, pop.firstChild);
  }

  function removeSheetTitle(pop) {
    if (!pop) return;
    var t = pop.querySelector('.qa-sheet-title');
    if (t && t.parentNode) t.parentNode.removeChild(t);
  }

  // Mobile sheet: a close (×) button in the top-right corner.
  function showCloseButton(wrap) {
    var pop = wrap && (wrap.__qaPop || wrap.querySelector('.qa-popover'));
    if (!pop || pop.querySelector('.qa-close-btn')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'qa-close-btn';
    btn.setAttribute('aria-label', 'Close');
    btn.innerHTML = '&times;';
    btn.addEventListener('click', function () { closeActive(); });
    pop.appendChild(btn);
  }

  function removeCloseButton(pop) {
    if (!pop) return;
    var b = pop.querySelector('.qa-close-btn');
    if (b && b.parentNode) b.parentNode.removeChild(b);
  }

  function showPreview(pill) {
    var pop = pill.closest('.qa-popover');
    if (!pop) return;
    var img = pop.querySelector('.qa-preview-img');
    if (!img) return;
    var src = pill.getAttribute('data-preview-src');
    if (!src) return;
    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    var priceEl = pop.querySelector('.qa-preview-price');
    if (priceEl) {
      var now = pill.getAttribute('data-preview-price') || '';
      var was = pill.getAttribute('data-preview-was') || '';
      var onSale = pill.getAttribute('data-preview-sale') === 'true';
      var priceHTML = (onSale && was)
        ? '<span class="qa-preview-now">' + now + '</span><span class="qa-preview-was-line">WAS <s class="qa-preview-was">' + was + '</s></span>'
        : now;
      if (priceEl.innerHTML !== priceHTML) priceEl.innerHTML = priceHTML;
    }
    var badgeEl = pop.querySelector('.qa-preview-badge');
    if (badgeEl) {
      var salePct = pill.getAttribute('data-preview-pct') || '';
      var saleOn = pill.getAttribute('data-preview-sale') === 'true';
      if (saleOn && salePct && salePct !== '0') {
        badgeEl.textContent = salePct + '% OFF';
        badgeEl.hidden = false;
      } else {
        badgeEl.hidden = true;
      }
    }
    var nameEl = pop.querySelector('.qa-preview-name');
    if (nameEl) {
      var brand = pill.getAttribute('data-brand') || '';
      var scent = pill.getAttribute('data-musk-name') || pill.getAttribute('data-product-title') || '';
      // Render brand and scent as separate elements so each can be styled
      // (small spaced brand eyebrow over a bolder scent name). Keyed so we
      // only rebuild the DOM when the product actually changes, not on every
      // pill hover within the same popover.
      var nameKey = brand + '|' + scent;
      if (nameEl.getAttribute('data-name-key') !== nameKey) {
        nameEl.setAttribute('data-name-key', nameKey);
        nameEl.textContent = '';
        if (brand) {
          var brandEl = document.createElement('span');
          brandEl.className = 'qa-preview-brand';
          brandEl.textContent = brand;
          nameEl.appendChild(brandEl);
        }
        if (scent) {
          var scentEl = document.createElement('span');
          scentEl.className = 'qa-preview-scent';
          scentEl.textContent = scent;
          nameEl.appendChild(scentEl);
        }
      }
    }
    // Show which variant option is currently selected (e.g. "Size: 1ML"),
    // important on mobile where the armed pill shows a cart icon instead of its
    // label, but also clearer on desktop.
    var variantEl = pop.querySelector('.qa-preview-variant');
    if (!variantEl) {
      var previewBox = pop.querySelector('.qa-preview');
      if (previewBox) {
        variantEl = document.createElement('div');
        variantEl.className = 'qa-preview-variant';
        previewBox.appendChild(variantEl);
      }
    }
    if (variantEl) {
      var isAtom = !!pill.closest('.qa-pills-atomizers');
      var group = isAtom ? 'Atomizer' : 'Size';
      var opt = (pill.textContent || '').replace(/\s+/g, ' ').trim();
      if (isAtom && opt) opt += ' (10ml)'; // atomizers are a 10ml size
      variantEl.textContent = opt ? group + ': ' + opt : '';
    }

    // Point Buy Now at whatever is previewed right now (hover on desktop, the
    // armed pill on touch).
    syncBuyNowButton(pop, pill);

    pop.classList.add('qa-preview-active');
  }

  function resetPopoverPosition(pop) {
    if (!pop) return;
    pop.style.position = '';
    pop.style.left = '';
    pop.style.top = '';
    pop.style.right = '';
    pop.style.bottom = '';
    pop.style.width = '';
  }

  function positionPopover(wrap) {
    var pop = wrap && wrap.__qaPop;
    var btn = wrap && wrap.querySelector('.qa-btn');
    if (!btn || !pop) return;

    // Mobile: full-width bottom sheet.
    if (isMobileViewport()) {
      pop.style.position = 'fixed';
      pop.style.top = 'auto';
      pop.style.right = 'auto';
      pop.style.left = '0px';
      pop.style.bottom = '0px';
      pop.style.width = window.innerWidth + 'px';
      return;
    }

    var card = wrap.closest('.main-slider, .recently-viewed__card') || btn;
    var cardRect = card.getBoundingClientRect();
    var btnRect = btn.getBoundingClientRect();
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var margin = 8;

    pop.style.position = 'fixed';
    pop.style.top = 'auto';
    pop.style.right = 'auto';

    var width = Math.min(cardRect.width, vw - margin * 2);
    pop.style.width = width + 'px';

    var left = cardRect.left;
    if (left + width > vw - margin) left = vw - width - margin;
    if (left < margin) left = margin;
    pop.style.left = left + 'px';

    pop.style.bottom = (vh - btnRect.top + 10) + 'px';
  }

  function scrollWrapIntoFrame(wrap, onDone) {
    var btn = wrap && wrap.querySelector('.qa-btn');
    if (!btn) { if (onDone) onDone(); return; }

    var rect = btn.getBoundingClientRect();
    var vh = window.innerHeight;
    // Anchor the button bottom near 80% of the viewport so there's
    // ~80% of viewport height available above for the popover (with preview).
    var targetBottom = vh * 0.8;
    var deltaY = rect.bottom - targetBottom;
    var maxUp = window.scrollY;
    var maxDown = (document.documentElement.scrollHeight - window.scrollY - vh);
    if (deltaY < 0) deltaY = Math.max(deltaY, -maxUp);
    else deltaY = Math.min(deltaY, maxDown);

    if (Math.abs(deltaY) < 8) { if (onDone) onDone(); return; }

    programmaticScroll = true;
    window.scrollBy({ top: deltaY, behavior: 'smooth' });
    setTimeout(function () {
      programmaticScroll = false;
      if (onDone) onDone();
    }, 450);
  }

  function openPopover(wrap) {
    var pop = wrap.__qaPop || wrap.querySelector('.qa-popover');
    if (!pop) return;

    if (!pop.__qaOrigParent) {
      pop.__qaOrigParent = pop.parentNode;
      pop.__qaOrigNext = pop.nextSibling;
    }
    pop.__qaWrap = wrap;
    wrap.__qaPop = pop;

    wrap.classList.add('qa-open');
    var btn = wrap.querySelector('.qa-btn');
    if (btn) btn.setAttribute('aria-expanded', 'true');

    var mount = function () {
      if (!wrap.classList.contains('qa-open')) return;

      if (pop.parentNode !== document.body) {
        document.body.appendChild(pop);
      }
      pop.classList.add('qa-open');
      positionPopover(wrap);
    };

    // Mobile bottom sheet: show the backdrop and mount immediately (no need to
    // scroll the card's button into view). Desktop: scroll it into frame first.
    if (isMobileViewport()) {
      setSheetTitle(wrap);
      showCloseButton(wrap);
      showBackdrop();
      mount();
    } else {
      scrollWrapIntoFrame(wrap, mount);
    }
  }

  function closePopover(wrap) {
    if (!wrap) return;
    var pop = wrap.__qaPop;

    hideBackdrop();
    wrap.classList.remove('qa-open');
    var btn = wrap.querySelector('.qa-btn');
    if (btn) btn.setAttribute('aria-expanded', 'false');

    if (pop) {
      pop.classList.remove('qa-open');
      clearPreview(pop);
      removeSheetTitle(pop);
      removeAddButton(pop);
      removeBuyNowButton(pop);
      removeActions(pop);
      removeCloseButton(pop);
      resetPopoverPosition(pop);

      if (pop.__qaOrigParent && pop.parentNode === document.body) {
        pop.__qaOrigParent.insertBefore(pop, pop.__qaOrigNext || null);
      }
    }
  }

  function closeActive() {
    if (!activeWrap) return;
    closePopover(activeWrap);
    activeWrap = null;
  }

  var PILL_DATA_ATTRS = ['variant-id', 'variant-title', 'product-title', 'product-image', 'musk-name', 'parfum', 'brand'];

  // Copy a pill's product/variant identity onto an action button, so the cart
  // drawer's shared handlers act on exactly that variant.
  function applyPillData(btn, pill) {
    for (var i = 0; i < PILL_DATA_ATTRS.length; i++) {
      btn.setAttribute('data-' + PILL_DATA_ATTRS[i], (pill && pill.getAttribute('data-' + PILL_DATA_ATTRS[i])) || '');
    }
  }

  // Both action buttons live in one sticky footer inside the popover, so on the
  // mobile sheet they stay visible together while the pills scroll behind them.
  function ensureActions(pop) {
    if (!pop) return null;
    var actions = pop.querySelector('.qa-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'qa-actions';
      pop.appendChild(actions);
    }
    return actions;
  }

  function removeActions(pop) {
    if (!pop) return;
    var actions = pop.querySelector('.qa-actions');
    if (actions && actions.parentNode) actions.parentNode.removeChild(actions);
  }

  // The "Add to Bag" button rendered below the pills once a size is selected
  // (desktop and touch alike). It carries the selected pill's data + the
  // add-to-bag-button class, so the cart drawer's existing handler adds that
  // exact variant.
  function showAddButton(pop, pill) {
    if (!pop || !pill) return;
    var actions = ensureActions(pop);
    var btn = actions.querySelector('.qa-add-btn');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qa-add-btn add-to-bag-button';
      btn.textContent = 'Add to Bag';
      // Prepended so Add to Bag stays the first, primary action above Buy Now.
      actions.insertBefore(btn, actions.firstChild);
    }
    applyPillData(btn, pill);
    // Buy Now is created alongside Add to Bag, so the two always appear together
    // as a pair the moment a size is chosen.
    ensureBuyNowButton(pop);
    syncBuyNowButton(pop, pill);
  }

  function removeAddButton(pop) {
    if (!pop) return;
    var btn = pop.querySelector('.qa-add-btn');
    if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
  }

  // "Buy Now" — adds the chosen variant and goes straight to checkout, via the
  // shared .buy-now-button handler in snippets/custom-cart-drawer.liquid.
  //
  // Created by showAddButton() when a size is chosen, so it always appears as
  // the second half of the Add to Bag / Buy Now pair.
  function ensureBuyNowButton(pop) {
    if (!pop) return null;
    var actions = ensureActions(pop);
    var btn = actions.querySelector('.qa-buy-btn');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qa-buy-btn buy-now-button';
      btn.textContent = 'Buy Now';
      btn.disabled = true;
      actions.appendChild(btn);
    }
    return btn;
  }

  function syncBuyNowButton(pop, pill) {
    if (!pop) return;
    var btn = pop.querySelector('.qa-buy-btn');
    if (!btn) return;
    applyPillData(btn, pill);
    btn.disabled = !pill || !!pill.disabled || !pill.getAttribute('data-variant-id');
  }

  function removeBuyNowButton(pop) {
    if (!pop) return;
    var btn = pop.querySelector('.qa-buy-btn');
    if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
  }

  // Pill click (capture phase, before the cart drawer's add handler on body).
  // Choosing a size only SELECTS it (highlight + preview) and reveals the
  // "Add to Bag" / "Buy Now" pair below — the pill never adds to cart on its
  // own. The pills still carry the .add-to-bag-button class from the card
  // snippets, so stopImmediatePropagation is what holds the drawer's add
  // handler off; that keeps this a JS-only change across all five card
  // surfaces.
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.qa-pill');
    if (!pill || pill.disabled) return;

    var pop = pill.closest('.qa-popover');
    if (pop) {
      var others = pop.querySelectorAll('.qa-pill[data-qa-armed]');
      for (var i = 0; i < others.length; i++) others[i].removeAttribute('data-qa-armed');
    }
    pill.setAttribute('data-qa-armed', 'true');
    showPreview(pill);
    showAddButton(pop, pill);

    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  // "Add to Bag": the add itself runs via the cart drawer's .add-to-bag-button
  // handler on this same click; close the popover just after (deferred so the
  // button isn't detached before that handler reads its data). Buy Now needs no
  // equivalent — it navigates to checkout.
  document.addEventListener('click', function (e) {
    if (e.target.closest('.qa-add-btn')) setTimeout(closeActive, 0);
  }, true);

  // Mobile: while the bottom sheet is open, the first tap anywhere outside it
  // just closes the sheet. Capture phase + preventDefault/stopPropagation so the
  // tap is swallowed and doesn't also activate whatever is behind it (e.g. a
  // product card link). Product cards can paint above the backdrop, so relying
  // on the backdrop alone isn't enough.
  document.addEventListener('click', function (e) {
    if (!isMobileViewport() || !activeWrap) return;
    if (e.target.closest('.qa-popover') || e.target.closest('.qa-btn') || e.target.closest('.qa-pill') || e.target.closest('.qa-add-btn')) return;
    e.preventDefault();
    e.stopPropagation();
    closeActive();
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qa-btn');

    if (btn && !btn.classList.contains('add-to-bag-button')) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = btn.closest('.qa-wrap');
      if (activeWrap && activeWrap !== wrap) closeActive();
      if (wrap.classList.contains('qa-open')) {
        closePopover(wrap);
        activeWrap = null;
      } else {
        openPopover(wrap);
        activeWrap = wrap;
      }
      return;
    }
    if (btn) return;

    if (!e.target.closest('.qa-wrap') && !e.target.closest('.qa-popover')) closeActive();
  });

  function hasSelection(pop) {
    return !!(pop && pop.querySelector('.qa-pill[data-qa-armed="true"]'));
  }

  document.addEventListener('mouseover', function (e) {
    if (isTouchLike()) return; // touch uses tap-to-preview; ignore synthetic hover
    var pill = e.target.closest && e.target.closest('.qa-pill');
    if (!pill || pill.disabled) return;
    // A chosen size wins over hover, so the preview can't drift away from what
    // the Add to Bag / Buy Now buttons are actually pointed at.
    if (hasSelection(pill.closest('.qa-popover'))) return;
    showPreview(pill);
  });

  document.addEventListener('mouseout', function (e) {
    if (isTouchLike()) return; // touch uses tap-to-preview; ignore synthetic hover
    var pill = e.target.closest && e.target.closest('.qa-pill');
    if (!pill) return;
    var pop = pill.closest('.qa-popover');
    if (hasSelection(pop)) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('.qa-popover') === pop) return;
    if (pop) pop.classList.remove('qa-preview-active');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeActive();
  });

  window.addEventListener('scroll', function () {
    if (programmaticScroll) return;
    if (activeWrap) closeActive();
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (activeWrap) positionPopover(activeWrap);
  });

  // ---- Single-variant cards ----
  // Cards for a product with only one buyable variant render a direct
  // "Quick Add" (.qa-btn.add-to-bag-button) and no popover, so there's nowhere
  // to put a Buy Now. Inject one beneath it. Done here rather than in each card
  // snippet because five surfaces render this markup (collection grid, search,
  // both product sliders, recently-viewed) and recently-viewed builds its cards
  // in JS after load.
  function addInlineBuyNow(quickAddBtn) {
    if (!quickAddBtn || quickAddBtn.dataset.qaBuyNowBound === '1') return;
    quickAddBtn.dataset.qaBuyNowBound = '1';

    // Sold out — the Quick Add is already disabled, so there's nothing to buy.
    if (quickAddBtn.disabled) return;

    var wrap = quickAddBtn.closest('.qa-wrap');
    if (!wrap) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'qa-buy-btn-inline buy-now-button';
    btn.textContent = 'Buy Now';
    applyPillData(btn, quickAddBtn);
    wrap.appendChild(btn);
  }

  function scanForSingleVariantCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var btns = scope.querySelectorAll('.qa-btn.add-to-bag-button');
    for (var i = 0; i < btns.length; i++) addInlineBuyNow(btns[i]);
  }

  scanForSingleVariantCards(document);

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.qa-btn.add-to-bag-button')) addInlineBuyNow(node);
        scanForSingleVariantCards(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
